import React from 'react'

export default function Dots() {
  return <span className="dots" />
}
